import { render, staticRenderFns } from "./DayPartSelect.vue?vue&type=template&id=08081bb1&scoped=true"
import script from "./DayPartSelect.vue?vue&type=script&lang=ts"
export * from "./DayPartSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08081bb1",
  null
  
)

export default component.exports